/* CAPPONI — Cierre del añadido rápido con UpCart (Kevin, 06/09).
 *
 * Antes, la hoja del añadido rápido (quick-add) la cerraba el flujo nativo de
 * Horizon al completar el añadido. UpCart intercepta el envío y añade por su
 * cuenta, así que ese flujo nunca termina y la hoja se quedaba abierta debajo
 * del cajón de UpCart. Aquí se vigila cualquier añadido al carrito (fetch o
 * XHR a /cart/add) y, si sale bien, se cierra la hoja.
 *
 * Este script debe cargar ANTES que UpCart (va en el <head>, sin defer, antes
 * de content_for_header): si UpCart guardase su propia referencia a fetch
 * primero, el envoltorio no vería sus llamadas.
 */
(function () {
  function cerrarQuickAdd() {
    var comp = document.getElementById('quick-add-dialog');
    if (!comp) return;
    var dlg = comp.querySelector('dialog');
    if (!dlg || !dlg.open) return;
    try {
      if (typeof comp.closeDialog === 'function') {
        comp.closeDialog();
      } else {
        dlg.close();
      }
    } catch (e) {
      try {
        dlg.close();
      } catch (e2) {
        /* nada mas que hacer */
      }
    }
  }

  function esAnadido(url) {
    return typeof url === 'string' && url.indexOf('/cart/add') !== -1;
  }

  var fetchOriginal = window.fetch;
  window.fetch = function () {
    var url = typeof arguments[0] === 'string' ? arguments[0] : arguments[0] && arguments[0].url;
    var promesa = fetchOriginal.apply(this, arguments);
    if (esAnadido(url)) {
      promesa
        .then(function (r) {
          if (r && r.ok) setTimeout(cerrarQuickAdd, 250);
        })
        .catch(function () {});
    }
    return promesa;
  };

  var openOriginal = XMLHttpRequest.prototype.open;
  var sendOriginal = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (metodo, url) {
    this.__capponiUrl = url;
    return openOriginal.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (esAnadido(String(this.__capponiUrl || ''))) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) setTimeout(cerrarQuickAdd, 250);
      });
    }
    return sendOriginal.apply(this, arguments);
  };
})();
